<template>
  <error-page :message="message" status="403"></error-page>
</template>

<script>
import errorPage from "./error-page.vue";
export default {
  components: { errorPage },
  props: { message: String }
};
</script>
